import { Component, OnInit, ViewEncapsulation, AfterViewInit, OnDestroy } from '@angular/core';
// import { Helpers } from '../../../helpers';
import { UserService } from '../../../auth/_services';
import { ApptApi } from '../../../api/api-appt';
import { environment } from '../../../../environments/environment.prod';
import { GlobalErrorHandler } from '../../../_services/error-handler.service';

declare let mLayout: any;
@Component({
    selector: "app-aside-nav",
    templateUrl: "./aside-nav.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class AsideNavComponent implements OnInit, AfterViewInit, OnDestroy {
    s: any = null;
    admin_view: boolean = false;
    login: boolean = false;

    access: any = {
        'custom_text': {},
        'admin_user': {},
        'holiday': {},
        'location_group': {},
        'location': {},
        'package': {},
        'customer_data': {},
        'appointment': {},
        'confirm_appt': {},
        'deny_appt': {},
        'reschedule_appt': {},
        'cancel_appt': {},
    };

    badge_count = "";

    constructor(private userService: UserService, private apptApi: ApptApi, private errHandler: GlobalErrorHandler) {

    }

    ngOnInit() {
        this.s = this.userService.loggedIn.subscribe(
            result => {
                this.load();
            }
        );
        this.load();
    }

    ngAfterViewInit() {
        mLayout.initAside();
    }

    load() {
        // console.info(new Date(), 'load');
        let user = UserService.getUser();
        let level = UserService.getAccess();
        let tmp = {};
        level.forEach((e) => {
            tmp[e.action_id] = {
                view: e.view,
                add: e.add,
                edit: e.edit,
                delete: e.delete
            };
        });

        if (user) {
            this.login = true;
            this.admin_view = (user.level === "99" || user.level === "89");
            this.access = tmp;

            if (this.admin_view) {
                // console.info('get badge count', new Date());
                this.apptApi.pendingCount().subscribe(
                    data => {
                        if (!environment.production) console.info(data);
                        if (data instanceof Array && data.length) {
                            this.badge_count = data[0].COUNT;
                        }
                    }, error => {
                        this.errHandler.handleError(error);
                    });
            }
            // console.info(this.access);
        } else {
            this.login = false;
        }
    }

    ngOnDestroy() {
        if (this.s) this.s.unsubscribe();
    }
}


// WEBPACK FOOTER //
// ./src/app/theme/layouts/aside-nav/aside-nav.component.ts